import PropTypes from "prop-types";
import React from "react";

import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";

import { useSelector } from "react-redux";
import { createSelector } from "reselect";

// Import Routes all
import { pmProtectedRoutes, authProtectedRoutes, publicRoutes } from "./routes";
import RentalApplicationPage from "./pages/Apply/RentalApplicationPage";
import ListingsGallery from "./pages/Apply/ListingsGallery";

// Import all middleware
import Authmiddleware from "./routes/route";

import { AuthProvider } from "./hooks/AuthProvider"; // ✅ Import AuthProvider
import { AuthStatusProvider } from "./hooks/useAuthStatus"; // ✅ Import AuthProvider
import { RoleProvider } from "./context/RoleContext"; // ✅ Import RoleProvider

import {AppInitializer} from './components/AppInitializer'
import AppErrorBoundary from "./components/Common/AppErrorBoundary";
import MaintenanceGate from "./components/Common/MaintenanceGate";
import { ErrorPage, MaintenancePage, NotFoundPage } from "./pages/System/SystemStatusPage";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import ListingLayout from "./components/ListingLayout";

// Import scss
import "./assets/scss/theme.scss";

import "./firebaseConfig"; // Import to initialize Firebase

const App = (props) => {
  const selectLayoutState = (state) => state.Layout;
  const LayoutProperties = createSelector(
    selectLayoutState,
      (layout) => ({
        layoutType: layout.layoutType,
      })
  );

    const {
      layoutType
  } = useSelector(LayoutProperties);

  function getLayout(layoutType) {
    let layoutCls = VerticalLayout;
    switch (layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout(layoutType);

  return (
    <AppErrorBoundary>
      <AuthProvider> 
        <AuthStatusProvider> {/* ✅ Wrap once at the top */}
        <RoleProvider> {/* ✅ Track active role context */}
        <AppInitializer> {/* 🌀 Spins wheel */}
        <MaintenanceGate>
          <Routes>
            <Route path="/error" element={<ErrorPage onRetry={() => window.location.assign("/")} />} />
            <Route path="/maintenance" element={<MaintenancePage />} />

            <Route path="/rentals" element={<NonAuthLayout><ListingLayout><ListingsGallery /></ListingLayout></NonAuthLayout>} />
            <Route path="/rentals/:listingId" element={<NonAuthLayout><ListingLayout><RentalApplicationPage /></ListingLayout></NonAuthLayout>} />
            <Route path="/apply/:listingId" element={<NonAuthLayout><ListingLayout><RentalApplicationPage /></ListingLayout></NonAuthLayout>} />

            {publicRoutes.map((route, idx) => {
              return (
                <Route
                  key={idx}
                  path={route.path}
                  element={<NonAuthLayout>{route.component}</NonAuthLayout>}
                  exact={true}
                />
              );
            })}

            {authProtectedRoutes.map((route, idx) => (
              <Route
                key={`auth-${idx}`}
                path={route.path}
                element={
                  <Authmiddleware>
                    <Layout>{route.component}</Layout>
                  </Authmiddleware>
                }
                exact
              />
            ))}

            {pmProtectedRoutes.map((route, idx) => (
              <Route
                key={`pm-${idx}`}
                path={route.path}
                element={
                  <Authmiddleware>
                    <Layout>{route.component}</Layout>
                  </Authmiddleware>
                }
                exact
              />
            ))}

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </MaintenanceGate>
          </AppInitializer>
        </RoleProvider> {/* ✅ Close role context */}
        </AuthStatusProvider> {/* ✅ Close wrapper here */}
      </AuthProvider>
    </AppErrorBoundary>
);
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
